import React, { createContext, useCallback, useContext, useState } from 'react'
import useActionBarWidth from 'components/common/hooks/useActionBarWidth'

const AppSettingsContext = createContext(null)

export const AppSettingsProvider = ({ children }) => {
  const actionBarWidthState = useActionBarWidth()

  const [title, setTitle] = useState('')
  const [showActiveWellDetails, setShowActiveWellDetails] = useState(false)
  const [wellDetails, setWellDetails] = useState(null)

  // wellDetails used to override the details in Well Planning
  const setPageTitle = useCallback((currentTitle, showWellDetails = false, wellDetails) => {
    setTitle(currentTitle)
    setShowActiveWellDetails(showWellDetails)
    setWellDetails(wellDetails)
  }, [])

  return (
    <AppSettingsContext.Provider
      value={{
        ...actionBarWidthState,
        pageTitle: title,
        showActiveWellDetails,
        setPageTitle,
        wellDetails,
      }}>
      {children}
    </AppSettingsContext.Provider>
  )
}

export const useAppSettings = () => {
  const ctx = useContext(AppSettingsContext)

  if (!ctx) {
    throw new Error('useAppSettings must be used within an AppSettingsProvider')
  }

  return ctx
}
